import MISC from 'src/utils/helper/misc.js'
const { sigUrl } = MISC.getAuth0CredDetails()

const Render = (() => {
  /*
   * Returns Uri of rendered fontface of a binary.
   * Render options are available here: https://www.fontshop.com/render_test
   *
   * Options in this Fn:
   * md5 (render needs md5 of binary for id parameter, default is from Malabar)
   * name
   * size
   *
   * Returns Uri
   */
  const _default = {
    md5: '300f04ca918f59925fa7322e4ee5f5fe',
    name: 'Hamburgefontsiv',
    size: 40,
    fg: '000000'
  }
  const _validateName = (name) => {
    return typeof name === 'string' && name.length > 0
      ? name
      : _default.name
  }
  const _validateSize = (size) => {
    return typeof size === 'number'
      ? size
      : _default.size
  }
  const _validateFg = (fg) => {
    return typeof fg === 'string' && fg.length > 0
      ? fg
      : _default.fg
  }
  const _get = (options) => {
    options.name = escape(_validateName(options.name))
    options.size = _validateSize(options.size)
    options.fg = _validateFg(options.fg)
    let uri = ''
    if (options?.md5?.length > 0) {
      uri = sigUrl + '/fonts/font_rend.php?' +
        'id=' + options.md5 +
        (options.rt ? '&rt=' + options.name : '') +
        '&appId=107' +
        '&fg=' + options.fg +
        '&tp=0' +
        '&rs=' + options.size +
        '&sc=' + (window.devicePixelRatio > 1 ? 2 : 1) +
        '&render_mode=new'
    }
    return uri
  }
  return {
    get: _get
  }
})()

export {
  Render
}
